module.exports = __webpack_public_path__ + "static/img/matchCol.17fa46b8.svg";